import React, { useRef, useEffect, useState } from "react";
import "./WorkCard.scss";

export default function WorkCard({ project, onClick, forceRevealed, sequenceNum, innerRef }) {
  const cardRef = useRef(null);
  const [observerRevealed, setObserverRevealed] = useState(false);

  // Set up standard IntersectionObserver for ongoing scroll/loop
  useEffect(() => {
    const card = cardRef.current;
    if (!card) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        setObserverRevealed(entry.isIntersecting);
      },
      {
        root: null,
        threshold: 0.2,
      }
    );

    observer.observe(card);
    return () => observer.disconnect();
  }, []);

  // Card is revealed if triggered by sequence OR by continuous intersection observer
  const isRevealed = forceRevealed !== undefined ? forceRevealed : observerRevealed;

  return (
    <div
      ref={(node) => {
        cardRef.current = node;
        if (innerRef) innerRef.current = node;
      }}
      data-seq={sequenceNum}
      className={`work-card work-card--${project.size} ${isRevealed ? "is-revealed" : ""}`}
      onClick={onClick}
      style={{ backgroundImage: `url(${project.image})` }}
      role="listitem"
      tabIndex={0}
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          onClick();
        }
      }}
    >
      <div className="work-card__overlay" />

      <div className="work-card__content">
        <span className="work-card__tag">
          {project.category} | {project.deliverable}
        </span>
        <h3 className="work-card__title">{project.title}</h3>
        <p className="work-card__location">{project.location}</p>
      </div>
    </div>
  );
}